import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import './welcomeView.scss';

/*-- Import required components --*/
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import { LandingPageViewEnum, WelcomeTileTypesEnum } from '../../utility/enums';

/*-- Imports for redux --*/
import { connect } from 'react-redux';

/**
 * Date     :   2020-06-16
 * Author   :   Dinushka Rukshan
 * Remarks  :   Website landing page with directions
 */

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        welcomePageTiles: state.welcomePageTiles,
    }
};

const mapDispatchToProps = {};

class WelcomeView extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    welcomeTileOnClick(param) {
        if (param === WelcomeTileTypesEnum.LoginTile) {
            this.props.changeActiveView(LandingPageViewEnum.LoginView);
        } else if (param === WelcomeTileTypesEnum.RegisterTile) {
            this.props.changeActiveView(LandingPageViewEnum.RegistrationView);
        } else if (param === WelcomeTileTypesEnum.TrackOrderTile) {
            this.props.changeActiveView(LandingPageViewEnum.TrackOrderView);
        } else if (param === WelcomeTileTypesEnum.BrowseStoreTile) {
            this.props.guestLogin();
        } else if (param === WelcomeTileTypesEnum.ContactUsExternal) {
            window.location.href = `/ContactUsExternal`;
        } else if (param === WelcomeTileTypesEnum.DonationModuleTile) {
            window.location.href = `/donation`;
        }
    };

    render() {
        return (
            <div style={this.props.isVisible ? { display: '' } : { display: 'none' }} className="landing-main-div">

                <Col lg="10" md="10" sm="10" xs="10" style={{ marginTop: "15rem" }}>
                    <Row>
                        <Col lg="6" md="6" sm="12" xs="12" className="landing-sub-div">
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <img src={KeellsLogo} className="img-fluid logo-view"></img>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text">Hello,</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text">Log into your</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text">account for a</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text">quick and easy</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text">shopping</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text">experience</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="12" xs="12">
                                    <span className="welcome-view-header-text" style={{ fontFamily: "Foco-Bold" }}>Happy shopping!</span>
                                </Col>
                            </Row>
                            <Row>

                            </Row>
                        </Col>
                        <Col lg="6" md="6" sm="12" xs="12">
                            <Row>
                                <div id="welcome_donation_btn" className="welcome-donation-tile"
                                    onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.DonationModuleTile)}>
                                    <i className="fas fa-heart"></i>
                                    <div className="landing-sub-header-padding">
                                        <div>
                                            <span className="landing-sub-header-text"><span style={{ fontFamily: "Foco-Bold" }}>Donate</span> Now </span>
                                        </div>
                                        <div>
                                            <span className="landing-paragraph-text">Click here</span>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <Row>
                                <div id="welcome_login_btn" className="welcome-tile" onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.LoginTile)}>
                                    <i className="fas fa-user"></i>
                                    <div className="landing-sub-header-padding">
                                        <div>
                                            <span className="landing-sub-header-text">Already <span style={{ fontFamily: "Foco-Bold" }}>Registered?</span></span>
                                        </div>
                                        <div>
                                            <span className="landing-paragraph-text">Login Here</span>
                                        </div>
                                    </div>
                                </div>
                                <div id="welcome_register_btn" className="welcome-tile" onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.RegisterTile)}>
                                    <i className="fas fa-unlock-alt"></i>
                                    <div className="landing-sub-header-padding">
                                        <div>
                                            <span className="landing-sub-header-text"><span style={{ fontFamily: "Foco-Bold" }}>New</span> to <span style={{ fontFamily: "Foco-Bold" }}>Keells?</span></span>
                                        </div>
                                        <div>
                                            <span className="landing-paragraph-text">Register here</span>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <Row>
                                <div id="welcome_track_btn" className="welcome-tile" onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.TrackOrderTile)}>
                                    <i className="fas fa-thumbtack"></i>
                                    <div className="landing-sub-header-padding">
                                        <div>
                                            <span className="landing-sub-header-text">Track <span style={{ fontFamily: "Foco-Bold" }}>your order?</span></span>
                                        </div>
                                        <div>
                                            <span className="landing-paragraph-text">Click here</span>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.props.welcomePageTiles.isShowBrowswStore ?
                                        <div id="welcome_browse_btn" className="welcome-tile" onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.BrowseStoreTile)}>
                                            <i className="fas fa-store"></i>
                                            <div className="landing-sub-header-padding">
                                                <div>
                                                    <span className="landing-sub-header-text">Browse <span style={{ fontFamily: "Foco-Bold" }}>the Store</span></span>
                                                </div>
                                                <div>
                                                    <span className="landing-paragraph-text">Click here</span>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <></>
                                }

                            </Row>
                            {/* <Row className="showInMobileContactUs" >
                                <div id="welcome_contact_btn_web" className="welcome-tile" onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.ContactUsExternal)}>
                                    <i className="fas fa-phone-alt"></i>
                                    <div className="landing-sub-header-padding">
                                        <div>
                                            <span className="landing-sub-header-text"><span style={{ fontFamily: "Foco-Bold" }}>Contact us</span></span>
                                        </div>
                                        <div>
                                            <span className="landing-paragraph-text">Click here</span>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <Row className="hideInMobileContactUs" >
                                <div id="tileHideTwo" className="welcome-tile" style={{ opacity: "0" }}>
                                    <span>.</span>
                                </div>
                                <div id="welcome_contact_btn_mobile" style={{ marginLeft: "5rem", marginTop: "5rem" }} className="contactUs-btn new-btn-secondary-contactus btn-v1-contactus" onClick={this.welcomeTileOnClick.bind(this, WelcomeTileTypesEnum.ContactUsExternal)}>
                                    <div className="landing-sub-header-padding">
                                        <div style={{ paddingTop: "0.5rem" }}>
                                            <span className="landing-sub-header-text"><span style={{ fontFamily: "Foco-Bold", padding: "3rem" }}>Contact Us</span></span>
                                        </div>
                                    </div>
                                </div>
                            </Row> */}
                        </Col>
                    </Row>
                </Col>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeView);